import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { FilterType, HTTPValidationError, HttpResponse, PaymentRead, PaymentStatus } from '@/api/dashboard'
import { DEMO_TRANSACTION_DATA } from '@/layouts/transaction/api/demo'

type Query = {
  /** Search String */
  search_string?: string
  /** Status */
  status?: PaymentStatus
  /**
   * Country
   * @pattern ^[A-Z]{2}$
   */
  countries?: string
  /** User Id */
  user_id?: string

  /** Start At */
  start_at?: number

  /** End At */
  end_at?: number

  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 100
   * @default 10
   */
  limit?: number
  /**
   * Offset
   * The number of objects to skip
   * @min 0
   */
  offset?: number

  /** @default "period" */
  type?: FilterType
}

/**
 *
 * @param companyId
 * @param gameId
 * @param query
 */
export const usePaymentsQuery = (companyId: string, gameId: string, query: Query = {}) => {
  return useQuery({
    queryKey: ['payments', gameId, query],
    queryFn: () => {
      if (gameId == import.meta.env.VITE_DEMO_GAME_ID) {
        return new Promise(resolve => {
          resolve({
            data: DEMO_TRANSACTION_DATA,
          })
        }) as unknown as Promise<HttpResponse<PaymentRead[], HTTPValidationError>>
      }
      return dashboardClient.v1.getPayments({ companyId, gameId, ...query })
    },
    select: response => response.data,
  })
}
